import getStore from '../store';
import { CalendarAccountErrorDialogState } from '../schema/CalendarAccountErrorDialogState';

export function getIsAccountError() {
    const errorState = getStore().errorState;
    return (
        errorState == CalendarAccountErrorDialogState.AccountLoadTokenError ||
        errorState == CalendarAccountErrorDialogState.AccountLoadNonTokenError
    );
}
